import request from '@/utils/request';
import { cohortVisualisationEndpoint } from '@/constants/urls';
import { cohortChart } from '../constants';

const cohortVisualisation = (variables, code, queryId, dictionaryCode, chartType) => (
  request({
    url: cohortVisualisationEndpoint(chartType, code),
    data: {
      ...variables,
      query_id: queryId,
      dictionary_code: dictionaryCode,
    },
    method: 'POST',
  })
);

const barChart = ({ xAxis }, cohortCode, queryId, dictionaryCode) => (
  cohortVisualisation(
    { column: xAxis.value },
    cohortCode,
    queryId,
    dictionaryCode,
    cohortChart.BAR,
  )
);

const stackedBarChart = ({ xAxis }, cohortCode, queryId, dictionaryCode) => (
  cohortVisualisation(
    { column: xAxis.value },
    cohortCode,
    queryId,
    dictionaryCode,
    cohortChart.STACKED_BAR,
  )
);

const boxPlot = ({ xAxis, yAxis }, cohortCode, queryId, dictionaryCode) => (
  cohortVisualisation(
    { x_axis_column: xAxis.value, y_axis_column: yAxis.value },
    cohortCode,
    queryId,
    dictionaryCode,
    cohortChart.BOX_PLOT,
  )
);

const histogram = ({ bins, yAxis }, cohortCode, queryId, dictionaryCode) => (
  cohortVisualisation(
    { column: yAxis.value, bins: bins.value },
    cohortCode,
    queryId,
    dictionaryCode,
    cohortChart.HISTOGRAM,
  )
);

const CohortVisualisationService = {
  barChart,
  stackedBarChart,
  boxPlot,
  histogram,
};

export default CohortVisualisationService;
